import(/* webpackMode: "eager" */ "/app/apps/ats-recruiter/app/global-error.tsx");
